const Paragraphs = ({ items }) => (items ?? []).map((t) => <p key={t} className="mt-4 text-[17px] leading-relaxed text-slate2">{t}</p>);

const Bullets = ({ items }) =>
  items?.length ? (
    <ul className="mt-4 space-y-3">
      {items.map((t) => (
        <li key={t} className="flex gap-3 text-[17px] leading-relaxed text-slate2">
          <span aria-hidden="true" className="mt-[0.7em] h-1.5 w-1.5 shrink-0 rounded-full bg-copper" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  ) : null;

const StorageList = ({ rows }) =>
  rows?.length ? (
    <div className="mt-5 grid gap-3 sm:grid-cols-2">
      {rows.map(([name, type, purpose, duration]) => (
        <div key={name} className="rounded-2xl border border-copper/20 bg-cream p-5" data-testid={`cookie-row-${name.split(",")[0]}`}>
          <p className="break-all font-medium text-navy">{name}</p>
          <p className="mt-1 text-[13px] uppercase tracking-[0.15em] text-copper-deep">{type}</p>
          <p className="mt-2 text-[15px] leading-relaxed text-slate2">{purpose}</p>
          <p className="mt-2 text-[14px] text-navy">Durata: {duration}</p>
        </div>
      ))}
    </div>
  ) : null;

export const sectionId = (docId, i) => `${docId}-s${i + 1}`;

export const LegalSection = ({ docId, section, index }) => (
  <section id={sectionId(docId, index)} className="scroll-mt-40 border-t border-copper/20 pt-10" data-testid={`legal-section-${index + 1}`}>
    <h2 className="font-display text-3xl font-medium leading-tight text-navy">{section.h}</h2>
    <Paragraphs items={section.p} />
    <Bullets items={section.list} />
    <StorageList rows={section.table} />
    <Paragraphs items={section.after} />
    {section.quote && (
      <blockquote className="mt-6 rounded-2xl border-l-4 border-copper bg-cream p-5 text-[16px] italic leading-relaxed text-navy" data-testid="withdrawal-form-text">
        {section.quote}
      </blockquote>
    )}
  </section>
);
